'use client'

import Link from "next/link";
import React, { useState } from "react";
import { SubmitButton } from "./submit-button";
import PasswordInput from "./PasswordInput";
import { signUpServer } from "../../functions/sign";
import Switcher from "../Switchers/Switcher";

export default function SignupForm() {
    const [privacyApproved, setPrivacyApproved] = useState(false);
    const domain = process.env.NEXT_PUBLIC_DOMAIN
    return (
        <div className="flex flex-col gap-9">
            <div className="rounded-sm bg-white dark:border-strokedark dark:bg-boxdark">
                <form>
                    {/* Email */}
                    <div className="mb-4">
                        <label
                            htmlFor="email"
                            className="mb-2.5 block font-medium text-black dark:text-white"
                        >
                            Email
                        </label>
                        <div className="relative">
                            <input
                                id="email"
                                name="email"
                                type="email"
                                placeholder="Enter your email"
                                className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 text-black outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                            />
                            <span className="absolute right-4 top-4 opacity-50">
                <svg
                    className="fill-current"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M19.25 3.3H2.75C1.58 3.3 0.59 4.26 0.59 5.47v11.14c0 1.17 0.96 2.17 2.16 2.17h16.5c1.17 0 2.17-0.96 2.17-2.17V5.43c0-1.17-1-2.13-2.17-2.13ZM11 10.21 2.65 4.85h16.7L11 10.21Zm8.25 6.94H2.75c-0.34 0-0.62-0.27-0.62-0.62V6.36l8.04 5.16c0.24 0.17 0.52 0.25 0.79 0.25s0.55-0.08 0.79-0.25l8.04-5.16v10.18c0 0.34-0.27 0.62-0.62 0.62Z"
                      fill="currentColor"
                  />
                </svg>
              </span>
                        </div>
                    </div>

                    {/* Passwords */}
                    <PasswordInput name="password" label="Password" />
                    <PasswordInput name="confirm_password" label="Re-type Password" />

                    {/* Privacy Switch */}
                    <div className="mb-4">
                        <Switcher
                            field="privacy"
                            onChange={setPrivacyApproved}
                            value={privacyApproved}
                        />
                        <div className="text-sm mt-2">
                            Accept{" "}
                            <Link
                                href={`${domain}/privacy-policy`}
                                target="_blank"
                                className="text-primary underline"
                            >
                                Privacy Policy
                            </Link>{" "}
                            and{" "}
                            <Link
                                href={`${domain}/terms-and-conditions`}
                                target="_blank"
                                className="text-primary underline"
                            >
                                Terms of Service
                            </Link>
                        </div>
                    </div>

                    {/* Submit */}
                    <SubmitButton
                        formAction={signUpServer}
                        className={`text-foreground mb-2 flex w-full justify-center rounded ${privacyApproved ? 'bg-primary text-white' : 'bg-gray text-dark'} px-4 py-3 font-medium hover:bg-opacity-90`}
                        pendingText="Signing Up..."
                        disabled={!privacyApproved}
                    >
                        Sign Up
                    </SubmitButton>

                    {/* Footer */}
                    <div className="mt-6 text-center text-sm">
                        Already have an account?{" "}
                        <Link href="/signin" className="text-primary underline">
                            Sign in
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
